<!-- plugin popover UI -->

<!-- If we are showing a plugin UI -->
<ng-container *ngIf="pluginController">

  <div class="fdm-plugin-popover" [id]="id+'pop'" [class.scale-up]="plugin" [hidden]="!plugin"> 
    <fa-icon class="fdm-linked fdm-text-large float-right" icon="times-circle" (click)="close()"></fa-icon>
    <plugin-ui *ngIf="plugin && item" [plugin]="plugin" [item]="item" [context]="context"></plugin-ui>
  </div>

  <!-- If we're showing a popover selection of plugin options -->
  <div class="fdm-plugin-popover-hover" [id]="id+'hover'" (mouseleave)="mouseLeave(selected_hover_item)"> 

    <ng-container *ngIf="selected_hover_item">
      <ng-container *ngFor="let shortcut of pluginController.listShortcuts(selected_hover_item)">
  
        <mat-chip *ngIf="shortcut.active" [matTooltip]="shortcut?.translator+'.DESCRIPTION' | translate"
          class="fdm-link fdm-plugin-chip" color="accent" selected 
          (click)="clickPluginShortcut(shortcut,selected_hover_item,$event);clickedPluginsHover();">
          {{shortcut?.label|translate}} <fa-icon [icon]="shortcut.icon ? shortcut.icon : 'cog'"></fa-icon>
        </mat-chip>
  
        <mat-chip *ngIf="!shortcut.active" [matTooltip]="shortcut?.translator+'.DESCRIPTION' | translate"
          class="fdm-link fdm-plugin-chip fdm-plugin-chip-accent"
          (click)="clickedPluginsHover(shortcut.name,selected_hover_item,$event);">
          {{shortcut?.label|translate}} <fa-icon icon="plus-circle"></fa-icon>
        </mat-chip>
  
      </ng-container>
    </ng-container>
  
  </div>
  
</ng-container>
